export const isNonNull = <T>(data: T): data is NonNullable<T> => {
  return data !== null && data !== undefined;
};

type HasNonNull<T, K extends keyof T> = K extends infer Key
  ? Key extends K
    ? NonNullable<T> & { [k in Key]-?: NonNullable<T[k]> }
    : never
  : never;

export const hasNonNull = <T, K extends keyof T>(key: K) => {
  return (data: T): data is HasNonNull<T, K> => {
    return data !== null && data !== undefined && data[key] !== null && data[key] !== undefined;
  };
};
